var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"export"},[_c('b-button',{attrs:{"size":"is-small"},on:{"click":function($event){return _vm.exportAsCsv()}}},[_vm._v(" Export "),_c('b-icon',{staticClass:"ml-1",attrs:{"icon":"file-csv","size":"is-small"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }